export default "__VITE_ASSET__D7O_Ciro__"